import * as React from 'react'
import { Text } from '$views/components/Text'
import facebookIcon from '$icons/facebook.svg'
import youtubeIcon from '$icons/youtube.svg'
import instagramIcon from '$icons/instagram.svg'
import googlePlayStoreIcon from '$icons/googlePlayStore.svg'
import appStoreIcon from '$icons/appStore.svg'
import { routeProvider } from '$utils/routeProvider'
import { GridFooter, StyledText, BlockAlignEnd, IconApp } from './Footer.styles'
import { FooterLink, FooterIconLink } from './FooterLink'
import { Block } from '$views/components/Layout/Block'

export const Footer: React.SFC<Props> = () => {
  return (
    <GridFooter>
      <div>
        <Text title color="white" cooper>
          Familiados
        </Text>
        <FooterLink href={routeProvider.help}>Ayuda</FooterLink>
        <FooterLink href={routeProvider.blog}>Blog</FooterLink>
      </div>
      <div>
        <Text title color="white" cooper>
          Cuidados
        </Text>
        <FooterLink href={routeProvider.kids} marginTop="small">
          Niños
        </FooterLink>
        <FooterLink href={routeProvider.adults}>Personas mayores</FooterLink>
        <FooterLink href={routeProvider.sickPeople}>Enfermos</FooterLink>
        <FooterLink href={routeProvider.hospitalCare}>Cuidado en hospital</FooterLink>
        <FooterLink href={routeProvider.alzheimer}>Alzheimer</FooterLink>
      </div>
      <div>
        <Text title color="white" cooper>
          Legal
        </Text>
        <FooterLink href={routeProvider.privacyPolicy} marginTop="small">
          Aviso legal y política de privacidad
        </FooterLink>
        <FooterLink href={routeProvider.termsOfService}>Condiciones generales</FooterLink>
        <FooterLink href={routeProvider.cookies}>Cookies</FooterLink>
      </div>
      <BlockAlignEnd flex>
        <FooterIconLink href={routeProvider.facebook} icon={facebookIcon} />
        <FooterIconLink href={routeProvider.instagram} icon={instagramIcon} />
        <FooterIconLink href={routeProvider.youtube} icon={youtubeIcon} />
      </BlockAlignEnd>
      <Block onlyDesktop />
      <BlockAlignEnd flex>
        <IconApp
          content={googlePlayStoreIcon}
          clickable
          onClick={() => (window.location.href = routeProvider.playStoreApp)}
        />
        <IconApp content={appStoreIcon} clickable onClick={() => (window.location.href = routeProvider.iosAppStore)} />
      </BlockAlignEnd>
      <StyledText weight="light" menu color="white" marginTop="large">
        Copyright © {new Date().getFullYear()} Familiados. Todos los derechos reservados.
      </StyledText>
    </GridFooter>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Footer/Footer.tsx